<template>
  <div>    
    <v-data-table
      :headers="[
        {text: '#', sortable: false, filterable: false, value: 'id'},
        {text: 'Datum', sortable: false, filterable: false, value: 'orderedAt'},
        {text: 'Typ', sortable: false, filterable: false, value: 'createdAt'},
        {text: 'Beställare', sortable: false, filterable: false, value: 'companyId'},
        {text: 'Referens', sortable: false, filterable: false, value: 'contactPersonId'},
        {text: 'Visa', sortable: false, filterable: false, value: 'updatedAt', align: 'center'},
      ]"
      :items="distanceOrders"
      :loading="isLoading"
      :options.sync="options"
      :server-items-length="totalRows"
      :items-per-page="itemsPerPage"
      item-key="id"      
    >
    <template
      slot="item.orderedAt"
      slot-scope="props"
    >
      <div >{{ props.item.orderedAt | date }}</div>
    </template>
    <template
      slot="item.createdAt"
    >
      <div >Distansbeställning</div>
    </template>
    <template
      slot="item.companyId"
      slot-scope="props"
    >
      <div >{{ props.item.company.name }}</div>
    </template>
    <template
      slot="item.contactPersonId"
      slot-scope="props"
    >
      <div >{{ props.item.contactPerson.firstName }} {{ props.item.contactPerson.lastName }}</div>
    </template>
    <template
      slot="item.updatedAt"
      slot-scope="props"
    >
    <v-btn text :to="{name: 'OrderDetail',params: {id: props.item.id}}">
          <v-icon>$sl-view-on</v-icon>Visa
        </v-btn>

      
    </template>

    </v-data-table>
  </div>
</template>

<script>
import API from '@/services/api.js'
import { mapGetters, mapActions } from 'vuex'
import { pageSize } from '@/store/constants'

export default {

  data: () => ({
    distanceOrders: [],
    options: {},
    itemsPerPage: pageSize,
    totalRows: 0
  }),

  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('person', ['selectedPerson']),
  },

  watch: {
    'currentPerson.personalNumber': {
      handler: function() {
        this.fetchDistanceOrders()
      }
    },
    options: {
      handler() {
        this.fetchDistanceOrders()
      },
      deep: true
    }
  },

  created() {
    this.fetchDistanceOrders()
  },

  methods: {
    // @vuese
    // Used to fetch distance orders
    // @arg The arguments are int repressenting company id , orderid , and data
    fetchDistanceOrders() {
      if ((!this.selectedPerson)) return

      const {sortBy, sortDesc, page, itemsPerPage} = this.options
      const startAt = (page - 1) * this.itemsPerPage

      API.listPersonDistanceOrders (this.selectedPerson.id,{
        startAt: startAt ? startAt : 0,
        sortBy: sortBy ? sortBy[0] : 'orderedAt',
        sortDesc: sortDesc ? sortDesc[0] : 'DESC',
        pageSize: this.itemsPerPage
      })
      .then(response => {
        this.distanceOrders = response.data.rows
        this.totalRows = response.data.count
      })
      .catch(error => {
        console.log('There was an error:', error.response)
      })
      
    }
  }

}
</script>

<style>

</style>